import { FC } from 'react';
import { contrast, isNotEmpty } from '@lhb/func';
import { ControlType } from '../config';
import V2FormProvinceList from 'src/common/components/Form/V2FormProvinceList/index';

enum AreaType {
  /** 省市区 */
  PROVINCE_CITY_DISTRICT = 1,
  /** 省市 */
  PROVINCE_CITY = 2,
}

/**
 * 省市区组件
 * @Description 目前只支持到省市区，后续如果有需要再扩展省市或者省
 * 传入的值为 { provinceId, provinceName, cityId, cityName, districtId, districtName } 或 { provinceId, provinceName, cityId, cityName }
 * 提交的值为 { provinceId, provinceName, cityId, cityName, districtId, districtName }
 */
const Provinces: FC<{
  form,
  propertyItem: any;
  required?: boolean;
  [k: string]: any,
}> = ({
  propertyItem,
  required,
  ...props
}) => {
  const label = propertyItem.anotherName || propertyItem.name || '';
  const restriction = propertyItem.restriction ? JSON.parse(propertyItem.restriction) : {};
  const placeholder = restriction.placeholder ? restriction.placeholder : (propertyItem.controlType === ControlType.CUSTOM_AREA.value ? `请选择${label}` : '请选择省市区');
  const rules = [
    { required, message: placeholder },
  ];

  /** 省市区格式：1 省市区，2 省市 */
  const type: AreaType = contrast(restriction, 'areaType', AreaType.PROVINCE_CITY_DISTRICT);
  // 如果需要用到省市区列表再取消注释
  // const provinceList = useSelector((state: any) => type === 1 ? state.common.provinceCityDistrict : state.common.provincesCities);

  return (<>
    <V2FormProvinceList
      label={label}
      name={propertyItem.identification}
      placeholder={placeholder}
      type={type}
      rules={rules}
      {...props}
      formItemConfig={{
        ...props?.formItemConfig,
        /** 转换 onChange 的值为指定格式 https://ant.design/components/form-cn#formitem */
        getValueFromEvent: (...[, options]) => {
          const value = (Array.isArray(options) ? options : []).slice(0, type === AreaType.PROVINCE_CITY_DISTRICT ? 3 : 2).filter(Boolean);
          return {
            'provinceId': value[0]?.id,
            'provinceName': value[0]?.name,
            'cityId': value[1]?.id,
            'cityName': value[1]?.name,
            'districtId': value[2]?.id,
            'districtName': value[2]?.name
          };
        },
        /** 转换传入的值为 [provinceId, cityId, districtId] */
        getValueProps: (value) => {
          let list: any[] = [];
          if (isNotEmpty(value?.provinceId) || isNotEmpty(value?.cityId) || isNotEmpty(value?.districtId)) { // 省市或省市区
            // 如果是独立的省市区组件，保存的值为 { provinceId, provinceName, cityId, cityName, districtId, districtName } 或 { provinceId, provinceName, cityId, cityName }
            // 目前只支持到省市区，后续如果有需要再扩展省市或者省
            list = [value?.provinceId, value?.cityId, value?.districtId];
          } else { // 兼容旧的结构（关联商圈的省市区会提前处理成 [1, 1, 1]）
            list = Array.isArray(value) ? value : [];
          }
          return { value: list.slice(0, type === AreaType.PROVINCE_CITY_DISTRICT ? 3 : 2).filter(Boolean) };
        }
      }}
    />
  </>
  );
};

export default Provinces;
